/* =========================================================

SEMI LOCATOR SIMULATOR — MAP PAGE V1

Create this as simulator-map.js in Shopify assets.



Requires:

- Mapbox GL JS loaded on the page

- window.SLX_MAPBOX_TOKEN OR #slxSimMapApp data-mapbox-token

========================================================= */



(function(){

"use strict";



if(window.__SLX_SIM_MAP_V1__) return;

window.__SLX_SIM_MAP_V1__ = true;



var app = document.getElementById("slxSimMapApp");

var mapEl = document.getElementById("slxSimMap");

var toastEl = document.getElementById("slxSimToast");

var startBtn = document.getElementById("simStartRoute");

var scanBtn = document.getElementById("simScanRoute");

var layersBtn = document.getElementById("simBtnLayers");

var weatherBtn = document.getElementById("simBtnWeather");

var networkBtn = document.getElementById("simBtnNetwork");



var map = null;

var mapReady = false;

var moving = false;

var routeProgress = 0;

var routeTimer = null;

var weatherVisible = true;

var networkVisible = true;



var MAPBOX_TOKEN = "";

if(window.SLX_MAPBOX_TOKEN){ MAPBOX_TOKEN = String(window.SLX_MAPBOX_TOKEN || ""); }

if(!MAPBOX_TOKEN && app && app.getAttribute("data-mapbox-token")){

  MAPBOX_TOKEN = String(app.getAttribute("data-mapbox-token") || "");

}



var dallas = [-96.7970, 32.7767];

var atlanta = [-84.3880, 33.7490];



var routeCoords = [

  [-96.7970,32.7767],

  [-95.3698,29.7604],

  [-93.7500,32.5159],

  [-90.0490,35.1495],

  [-86.7816,36.1627],

  [-84.3880,33.7490]

];



var signalCoords = [

  [-96.7970,32.7767],

  [-95.3698,29.7604],

  [-92.2896,34.7465],

  [-90.0490,35.1495],

  [-86.7816,36.1627],

  [-84.3880,33.7490],

  [-89.3985,32.2988],

  [-86.8025,33.5186],

  [-90.0715,29.9511]

];



var stormPoly = [[

  [-94.8,33.2],

  [-93.7,35.6],

  [-91.8,36.0],

  [-90.5,34.5],

  [-91.0,32.8],

  [-93.2,32.4],

  [-94.8,33.2]

]];



var fallbackHTML =

  '<div class="slx-fallback-map">' +

    '<div class="slx-fallback-route"></div>' +

  '</div>';



function showToast(msg){

  if(!toastEl) return;

  toastEl.innerHTML = msg;

  toastEl.className = "slx-map-toast show";

  setTimeout(function(){ toastEl.className = "slx-map-toast"; },2400);

}



function makeGeo(type, coords, props){

  return {

    type:"Feature",

    geometry:{ type:type, coordinates:coords },

    properties:props || {}

  };

}



function getPointOnRoute(t){

  if(t <= 0) return routeCoords[0];

  if(t >= 1) return routeCoords[routeCoords.length - 1];



  var totalSegments = routeCoords.length - 1;

  var exact = t * totalSegments;

  var idx = Math.floor(exact);

  var local = exact - idx;



  if(idx >= routeCoords.length - 1){

    return routeCoords[routeCoords.length - 1];

  }



  var a = routeCoords[idx];

  var b = routeCoords[idx + 1];



  return [

    a[0] + (b[0] - a[0]) * local,

    a[1] + (b[1] - a[1]) * local

  ];

}



function addMarker(lngLat, cls){

  var el = document.createElement("div");

  el.className = cls;

  return new mapboxgl.Marker(el).setLngLat(lngLat).addTo(map);

}



var truckMarker = null;



function initMarkers(){

  addMarker(dallas,"slx-city-marker");

  addMarker(atlanta,"slx-city-marker dest");

  truckMarker = addMarker(routeCoords[0],"slx-truck-marker");



  for(var i=0;i<signalCoords.length;i++){

    addMarker(signalCoords[i],"slx-signal-dot");

  }

}



function addMapLayers(){

  if(!map) return;



  map.addSource("sim-route-src",{ type:"geojson", data:makeGeo("LineString", routeCoords) });



  map.addLayer({

    id:"sim-route-glow",

    type:"line",

    source:"sim-route-src",

    layout:{ "line-cap":"round", "line-join":"round" },

    paint:{ "line-color":"#18b7ff", "line-width":14, "line-opacity":0.28, "line-blur":8 }

  });



  map.addLayer({

    id:"sim-route-core",

    type:"line",

    source:"sim-route-src",

    layout:{ "line-cap":"round", "line-join":"round" },

    paint:{ "line-color":"#4cc9ff", "line-width":4, "line-opacity":0.95 }

  });



  map.addSource("sim-storm-src",{ type:"geojson", data:makeGeo("Polygon", stormPoly) });



  map.addLayer({

    id:"sim-storm-fill",

    type:"fill",

    source:"sim-storm-src",

    paint:{ "fill-color":"#ff4238", "fill-opacity":0.22 }

  });



  map.addLayer({

    id:"sim-storm-line",

    type:"line",

    source:"sim-storm-src",

    paint:{ "line-color":"#ffb000", "line-width":2, "line-opacity":0.65 }

  });



  map.addSource("sim-signals-src",{

    type:"geojson",

    data:{

      type:"FeatureCollection",

      features:signalCoords.map(function(c){ return makeGeo("Point", c, {}); })

    }

  });



  map.addLayer({

    id:"sim-signal-pulse",

    type:"circle",

    source:"sim-signals-src",

    paint:{ "circle-radius":18, "circle-color":"#17f3ff", "circle-opacity":0.10, "circle-blur":0.7 }

  });

}



function updateTruck(){

  var p = getPointOnRoute(routeProgress);



  if(truckMarker){ truckMarker.setLngLat(p); }



  if(map && mapReady && moving){

    map.easeTo({ center:p, duration:450, zoom:5.9, pitch:55, bearing:-58 });

  }

}



function completeRoute(){

  moving = false;

  routeProgress = 1;

  updateTruck();

  showToast("LOAD DELIVERED — Empire expanded. +$28,750");

}



function startRoute(){

  if(moving) return;



  moving = true;

  routeProgress = 0;

  updateTruck();

  showToast("Route started — Dallas to Atlanta.");



  if(routeTimer){ clearInterval(routeTimer); }



  routeTimer = setInterval(function(){

    routeProgress += 0.006;



    if(routeProgress >= 1){

      clearInterval(routeTimer);

      routeTimer = null;

      completeRoute();

      return;

    }



    updateTruck();

  },70);

}



function scanCorridor(){

  showToast("Corridor scan complete — storm impact medium, signal coverage improving.");



  if(map && mapReady){

    map.flyTo({ center:[-90.8,33.9], zoom:5.2, pitch:48, bearing:-42, duration:1100 });

  }

}



function toggleWeather(){

  weatherVisible = !weatherVisible;



  if(map && mapReady && map.getLayer("sim-storm-fill")){

    map.setLayoutProperty("sim-storm-fill","visibility",weatherVisible ? "visible" : "none");

    map.setLayoutProperty("sim-storm-line","visibility",weatherVisible ? "visible" : "none");

  }



  showToast(weatherVisible ? "Weather layer enabled." : "Weather layer hidden.");

}



function toggleNetwork(){

  networkVisible = !networkVisible;



  if(map && mapReady && map.getLayer("sim-signal-pulse")){

    map.setLayoutProperty("sim-signal-pulse","visibility",networkVisible ? "visible" : "none");

  }



  showToast(networkVisible ? "Signal network enabled." : "Signal network hidden.");

}



function showLayers(){

  showToast("Layers: freight route, weather, signals, hubs.");

}



function initMap(){

  if(!mapEl) return;



  if(!MAPBOX_TOKEN || !window.mapboxgl){

    mapEl.innerHTML = fallbackHTML;

    showToast("Fallback map online. Add Mapbox token for live 3D map.");

    return;

  }



  mapboxgl.accessToken = MAPBOX_TOKEN;



  map = new mapboxgl.Map({

    container:"slxSimMap",

    style:"mapbox://styles/mapbox/dark-v11",

    center:[-90.8,33.9],

    zoom:5.2,

    pitch:52,

    bearing:-42,

    antialias:true,

    attributionControl:false

  });



  map.addControl(new mapboxgl.NavigationControl({visualizePitch:true}),"bottom-right");



  map.on("load",function(){

    mapReady = true;



    try{

      map.setFog({

        color:"rgb(8, 18, 32)",

        "high-color":"rgb(36, 92, 140)",

        "horizon-blend":0.08,

        "space-color":"rgb(2, 7, 19)",

        "star-intensity":0.15

      });

    }catch(err){}



    addMapLayers();

    initMarkers();

    showToast("Freight Horizon map online.");

  });

}



function bind(){

  if(startBtn){ startBtn.addEventListener("click",startRoute); }

  if(scanBtn){ scanBtn.addEventListener("click",scanCorridor); }

  if(layersBtn){ layersBtn.addEventListener("click",showLayers); }

  if(weatherBtn){ weatherBtn.addEventListener("click",toggleWeather); }

  if(networkBtn){ networkBtn.addEventListener("click",toggleNetwork); }

}



function init(){

  bind();

  initMap();

}



init();



})();